import { render, staticRenderFns } from "./Navigation-receiver.vue?vue&type=template&id=2ee97ff7&"
import script from "./Navigation-receiver.vue?vue&type=script&lang=js&"
export * from "./Navigation-receiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports